export enum ReadingRoutes {
    reading = 'aflaesningafgas', // Path corresponding to the component in charge to detect the reading type
    readingPlan = 'readingplan',
    readingsOverview = 'readings',
    annualReading = 'aflaesning',
    monthlyReading = 'maanedligaflaesning',
    terminationReading = 'slutaflaesning',
}
